module.exports = __webpack_public_path__ + "img/DSC_2759-xs.b5512cca.png";